import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import AddIcon from '@material-ui/icons/Add';

import amber from '@material-ui/core/colors/amber';

import { PortfolioCard } from '../Portfolio';
import Illustration from 'components/Illustration';

const styles = theme => ({
  root: {

  },
  button: {
    backgroundColor: amber[500],
    color: "#fff",
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  }
});

const PortfolioCards = ({ classes, portfolio, handleDialog }) => {
  return(
    <div>
      <div className={classes.header}>
        <div>
          <Typography variant="headline">
            Portfolio
          </Typography>
          <Typography variant="caption">
            Showcase your work.
          </Typography>
        </div>
        <Button
          className={classes.button}
          variant="fab"
          aria-label="add"
          onClick={() => handleDialog({ show: true })}
          >
          <AddIcon />
        </Button>
      </div>
      <div className={classes.row}>
        {portfolio.length > 0 &&
          portfolio.map((portfolioItem, i) => {
            return <PortfolioCard
                      key={i}
                      portfolioItem={portfolioItem}
                      handleDialog={handleDialog}
                    />
          })
        }
        {portfolio.length === 0 &&
          <Illustration
            imgKey="portfolio_amber"
            explainerText="Your pride and joy, evidence of the great work you've done! Add your best portfolio pics here."
            addItemText="Let’s get them entered by clicking the “Floating Action Button” at top right."
          />
        }
      </div>

    </div>
  );
};

const mapStateToProps = (state) => {
  const portfolio = state.websiteState.portfolio;
  return({
    portfolio
  });
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(PortfolioCards);



// WEBPACK FOOTER //
// ./src/components/admin/Website/Portfolio/PortfolioCards.jsx